import {
  WEEKLY_WALKTHROUGH_EVENTS,
  type WeeklyWalkthrough,
} from "./weekly-walkthrough-types";

export const PERFORMANCE_WEEKLY_WALKTHROUGHS = {
  "performance-heatmaps": {
    id: "performance-heatmaps",
    title: "Review Performance Heatmaps",
    ctaLabel: "Open demo",
    targetRoute: "/?weeklyWalkthrough=performance-heatmaps",
    targetAction: "Open Performance -> Dashboard.",
    outcome: "Compare ProjectX trade activity with the live futures heatmap.",
    prerequisites: "Desktop app; ProjectX credentials unlock trade activity.",
    targetTab: "performance",
    eventName: WEEKLY_WALKTHROUGH_EVENTS.performanceOpenView,
    eventDetail: { view: "dashboard", focus: "heatmaps" },
    dispatchDelayMs: 220,
    steps: [
      "Open Performance.",
      "Review ProjectX activity and futures daily heatmaps.",
      "Use Refresh after changing ProjectX credentials in Settings.",
    ],
  },
  "performance-strategy-builder": {
    id: "performance-strategy-builder",
    title: "Add an EdgeCaster Strategy",
    ctaLabel: "Try workflow",
    targetRoute: "/?weeklyWalkthrough=performance-strategy-builder",
    targetAction: "Open Performance -> EdgeCaster.",
    outcome: "Save a top Discovery setup with its active Average IV context.",
    prerequisites: "Edgeful Discovery provides the strategy shortlist.",
    targetTab: "performance",
    eventName: WEEKLY_WALKTHROUGH_EVENTS.performanceOpenView,
    eventDetail: { view: "edgecaster", focus: "strategy-builder" },
    dispatchDelayMs: 220,
    steps: [
      "Open Performance EdgeCaster.",
      "Choose the instrument, timeframe, and top Discovery setup.",
      "Review Average IV, then add it to your saved strategies.",
    ],
  },
  "trade-developer-backdrop": {
    id: "trade-developer-backdrop",
    title: "Open TradeDeveloper Backdrop",
    ctaLabel: "Open demo",
    targetRoute: "/?weeklyWalkthrough=trade-developer-backdrop",
    targetAction: "Open Performance -> TradeDeveloper.",
    outcome: "See the daily day/night backdrop and reflection modal.",
    prerequisites: "TradeDeveloper uses the signed-in profile when available.",
    targetTab: "performance",
    eventName: WEEKLY_WALKTHROUGH_EVENTS.performanceOpenView,
    eventDetail: { view: "developer" },
    dispatchDelayMs: 220,
    steps: [
      "Open Performance.",
      "Choose TradeDeveloper.",
      "Use the reflection prompt while the daily backdrop sets context.",
    ],
  },
  "war-room-weekly-board": {
    id: "war-room-weekly-board",
    title: "Open War Room Board",
    ctaLabel: "Open demo",
    targetRoute: "/?weeklyWalkthrough=war-room-weekly-board",
    targetAction: "Open Imperium -> War Room.",
    outcome: "Review the weekly desk board, voice state, and attached signals.",
    prerequisites: "Signed-in user; RiskFlow context improves attachments.",
    targetTab: "analysis",
    eventName: WEEKLY_WALKTHROUGH_EVENTS.warRoom,
    dispatchDelayMs: 160,
    steps: [
      "Open Imperium.",
      "Choose War Room.",
      "Review pinned items, source attachments, and voice controls.",
    ],
  },
  "imessage-onboarding": {
    id: "imessage-onboarding",
    title: "Set Up iMessage",
    ctaLabel: "Review setting",
    targetRoute: "/?weeklyWalkthrough=imessage-onboarding",
    targetAction: "Open Settings -> Provider API -> iMessage.",
    outcome: "Check Photon readiness and start the iMessage gateway.",
    prerequisites: "Desktop operator setup with a valid E.164 phone number.",
    targetTab: "settings",
    eventName: WEEKLY_WALKTHROUGH_EVENTS.settingsTab,
    eventDetail: { tab: "fintheon-api" },
    dispatchDelayMs: 160,
    steps: [
      "Open Provider API.",
      "Find iMessage and enter your E.164 phone number.",
      "Run setup, install Sidecar if needed, then start Gateway.",
    ],
  },
  "trading-browser-reload": {
    id: "trading-browser-reload",
    title: "Refresh Trading Browser",
    ctaLabel: "Try shortcut",
    targetRoute: "/?weeklyWalkthrough=trading-browser-reload",
    targetAction: "Open TradingView in the Trading Browser.",
    outcome: "Refresh the embedded chart without reloading Fintheon.",
    prerequisites: "Desktop app with Trading Browser enabled.",
    targetTab: "dashboard",
    eventName: WEEKLY_WALKTHROUGH_EVENTS.tradingBrowserOpen,
    eventDetail: { platform: "tradingview" },
    dispatchDelayMs: 160,
    steps: [
      "Open TradingView in the Trading Browser.",
      "Press Cmd+R to refresh the active browser pane.",
      "Use Cmd+Shift+R only when Fintheon itself should reload.",
    ],
  },
} as const satisfies Record<string, WeeklyWalkthrough>;
